import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { postObterBoletoAreaSacado } from 'api/boletos';
import { SkeletonLoader } from 'shared';
import './styles.scss';
import { abrirBoletos } from 'utils/boletos/abrir-boletos';

export default () => {
  const [isPending, setPending] = useState(false);
  const [message, setMessage] = useState(false);
  const { token } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const atualizado = queryParams.get('atualizado') === '1';

  useEffect(() => {
    abrirBoletoTitulo();
  }, []);

  const abrirBoletoTitulo = () => {
    const payload = atualizado ? { atualizado: 1 } : {};
    payload.tipo_retorno = 'html';
    abrirBoletos({
      payload,
      endPointObterBoleto: postObterBoletoAreaSacado,
      setPending,
      setMessage,
      boleto_propria_tela: true,
      configEndPoint: {
        headers: {
          Authorization: `Bearer ${decodeURIComponent(token)}`
        }
      }
    });
  };

  return (
    <SkeletonLoader isPending={isPending} width="100%" height="100px" count={8} widthRandomness={0}>
      {message && (
        <div className="alert alert-danger animated fadeIn" role="alert">
          {message}
        </div>
      )}
    </SkeletonLoader>
  );
};
